export default {
  name: '会展中心',
  filters: {
    region: '地区',
    all: '全部',
    china: '中国',
    nation: '国家',
    more: '更多',
    packUp: '收起'
  },
  total: '共',
  stripStadium: '条场馆',
  recommendedExhibition: '推荐展会',
  more: '更多',
  countryAndRegion: '国家地区',
  pavilionAddress: '场馆地址',
  pavilionArea: '场馆面积',
  squareMeter: '平方米'
}
